
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import DatePicker from 'vue2-datepicker'
import awaitEach from 'await-each'
import common_helper from '../../../common_helper'
Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'Boxtype',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		DatePicker,
	},

	data: function () {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,



			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',


			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			orderid: '',
			fromDateFlt: '',
			toDateFlt: '',
			limitExeed: '',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			listerrordata: [],
			warehousesearch: '',
			show: false,
			orderstatuslist: ['Resolved', 'NotResolved'],
			searchstatus: '',
			fromDateFltErr: '',
			toDateFltErr: '',
			dataFilter: {},
			searchstatus: '',
			selectedList: [],
		}
	},
	//uniwareFailedInvoiceList
	created: function () { },
	// when a page loads,mounted() will be call
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;

		this.reportname = this.$t('unicommerce.invoiceError.failedInvoiceFileName');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.clientsearch = this.clientid;
				// this.getWarehouseList();

				this.showSelectWarehouse = true;
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();



				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getfailedinvoicedata(3)
			}
		},


		////////
		// async getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'getClientAssociatedWarehouseList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listWarehouseData = result.data.data;
		// 		}
		// 	}
		// },

		// async getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listClientData = result.data.data;
		// 		}
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	if (type == 'list') {
		// 		this.clientid = this.clientsearch;
		// 		if (this.clientid) {

		// 			this.getWarehouseList();

		// 		}
		// 	} else {
		// 		this.clientid = this.client;
		// 		this.getWarehouseList();
		// 	}
		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();

		// 			}
		// 		} else {
		// 			this.warehouseid = this.warehouse;
		// 		}
		// 	}
		// },
		selectAllCheckbox() {
			this.selectedList = []
			let flag = document.getElementById("parentCheckBox").checked
			if (flag) {
				this.selectedList = this.listerrordata.filter((item) => {
					if (item.status == "NotResolved") {
						document.getElementById(item.orderid).checked = true
						return item
					}

				})
			}
			else {
				this.selectedList = []
				this.listerrordata.forEach(e => {
					if (e.status == "NotResolved")
						document.getElementById(e.orderid).checked = false
				})
			}
		},

		singleSelected(data) {
			if (document.getElementById(data.orderid).checked)
				this.selectedList.push(data)
			else if (this.selectedList != []) {
				this.selectedList = this.selectedList.filter((item) => {
					if (item.orderid != data.orderid)
						return item
				})
				document.getElementById("parentCheckBox").checked = false
			}
			if (this.selectedList == [])
				document.getElementById("parentCheckBox").checked = false

		},

		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		resetSomeFilter() {
			this.pageno = this.pageCount = 0;
			this.listerrordata = [];
			this.resultCount = 0;
			this.totalRows = 0;
		},

		// This function for get box list
		async getfailedinvoicedata(csvCheck = 0) {
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.selectedList.forEach(e => {
					document.getElementById(e.orderid).checked = false
				});
				this.selectedList = [];
				document.getElementById("parentCheckBox").checked = false
				//this.currentPage = 1;
			}

			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.resetSomeFilter();
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.resetSomeFilter();
				return false;
			}
			if (!this.fromDateFlt) {
				this.fromDateFltErr = this.$t('common.fromTypeError');
				this.resetSomeFilter();
				return false;
			}
			if (!this.toDateFlt) {
				this.toDateFltErr = this.$t('common.toDateError');
				this.resetSomeFilter();
				return false;
			}


			this.input = ({
				'clientid': window.localStorage.getItem('selectedClient'),
				'fromdate': this.dateFormat1(this.fromDateFlt),
				'todate': this.dateFormat2(this.toDateFlt),
				'warehouseid': window.localStorage.getItem('selectedWarehouse'),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'status': this.status,
				'csvData': csvCheck,
				'orderid': this.orderid,
				'status': this.searchstatus,
			});
			this.dataFilter = {}
			let str = '', value = '', dataFilter2 = {};
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter = str.concat(value);
					dataFilter2[k] = v;
				}
			})

			if (window.localStorage.getItem('selectedClient') && window.localStorage.getItem('selectedWarehouse')) {
				this.isLoading = true;
				let result = await common_helper.getRestApiResponse('POST', 'uniwareFailedInvoiceList', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					if (csvCheck == 1 || csvCheck == 3) {
						if (result.data.data[0].count < 10000) {

							this.show = true;
							this.download = false;
							this.listAuditDatacsv = [];
							if (csvCheck == 1) {
								this.csvFields = {
									'status': this.$t('common.status'),
									'orderid': this.$t('common.orderID'),
									'uniwareshipid': this.$t('unicommerce.invoiceError.uniwareShipmentID'),
									'wmsordercreationdate': this.$t('unicommerce.invoiceError.wmsordercreationdate'),
									'shipbydate': this.$t('unicommerce.invoiceError.shipByDate'),
									'noofattempts': this.$t('unicommerce.invoiceError.noofattempts'),
									'firsterrordateandtime': this.$t('unicommerce.invoiceError.firstErrorDateandTime'),
									'lasterordateandtime': this.$t('unicommerce.invoiceError.lastErorDateandTime'),
									'lasterror':  this.$t('unicommerce.invoiceError.lasterror'),
								};
								let dateFilter = ['wmsordercreationdate', 'shipbydate', 'firsterrordateandtime', 'lasterordateandtime'];
								let skipFilter = ['count', 'id', 'createddate', 'shipmentid', 'useremail', 'saleschannel']
								this.listerrordatacsv = [];
								this.listerrordatacsv = result.data.data;

								csvHelper.data.jsonToCSV(this.$t('unicommerce.invoiceError.failedInvoiceFileName'), this.listerrordatacsv, this.csvFields, dateFilter, skipFilter, dataFilter2);
							} else {
								this.csvFieldsForXls[this.$t('common.status')]='status',
								this.csvFieldsForXls[this.$t('common.orderID')]='orderid',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.uniwareShipmentID')]='uniwareshipid',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.wmsordercreationdate')]='wmsordercreationdate',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.shipByDate')]='shipbydate',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.noofattempts')]='noofattempts',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.firstErrorDateandTime')]='firsterrordateandtime',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.lastErorDateandTime')]='lasterordateandtime',
								this.csvFieldsForXls[this.$t('unicommerce.invoiceError.lasterror')]='lasterror',
								this.listReportDataforxls = result.data.data;

							}

						} else {

							this.$alertify.success("report size is large please download it from data transmission");
						}
					} else {
						if (result.data.data.length > 0) {
							this.listerrordata = result.data.data;
							this.resultCount = result.data.data[0].count;
							this.totalRows = Number(result.data.data[0].count);
							this.setPageCounts(result.data.data[0].count);
						} else {
							this.listerrordata = [];
							this.resultCount = 0;
							this.totalRows = 0;
							this.setPageCounts(0);
							this.$alertify.error(this.$t('srReport.dataNotFound'));
						}


					}
					this.isLoading = false;
					this.toDateFltErr = '';
					this.fromDateFltErr = '';
				}
			} else {
				this.listerrordata = [];
				this.resultCount = 0;
				this.setPageCounts(0);

				if (!this.clientid) {
					this.ClientErr = this.$t('common.clientError');
				}
				if (!this.warehouseid) {
					this.ClientErr = this.$t('common.warehouseError');
				}
			}
		},
		async refreshMultipleInvoice() {
			this.isLoading = true;
			await awaitEach(this.selectedList, async item => {
				this.input = ({
					'clientid': window.localStorage.getItem('selectedClient'),
					'orderid': item.orderid,
					'id': item.id,
					'saleschannel': item.saleschannel,
					'useremail': item.useremail,
					'shipmentid': item.shipmentid,
					'warehouseid': window.localStorage.getItem('selectedWarehouse')
				});
				await common_helper.getRestApiResponse('POST', 'refreshInvoiceRecord', this.input, this.$alertify)
			}).then(result => {
				this.isLoading = false;
				this.currentPage = 1
				this.getfailedinvoicedata(2);
			})
		},
		async refreshInvoice(item) {
			this.input = ({
				'clientid': window.localStorage.getItem('selectedClient'),
				'orderid': item.orderid,
				'id': item.id,
				'saleschannel': item.saleschannel,
				'useremail': item.useremail,
				'shipmentid': item.shipmentid,
				'warehouseid': window.localStorage.getItem('selectedWarehouse')
			});
			let poid = item.orderid
			this.isLoading = true;
			let result = await common_helper.getRestApiResponse('POST', 'refreshInvoiceRecord', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.isLoading = false;
				this.orderid = poid;
				this.currentPage = 1
				document.getElementById("orderid").value = poid
				this.getfailedinvoicedata(2);


			}


		},


		onPageChange(page) {
			this.currentPage = page;
			this.getfailedinvoicedata(2)
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},

		resetFormData() {
			this.selectedList = [];
			this.toDateFlt = '';
			this.fromDateFlt = '';
			this.fromDateFltErr = '';
			this.toDateFltErr = '';
			document.getElementById("parentCheckBox").checked = false;
			this.orderid = '';
			this.id = '';
			this.boxcondition = '';
			this.searchboxtype = '';
			this.boxtypesearch = '';
			this.boxid = '';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			this.listerrordata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.isLoading = false;
			if (this.user_type == 'warehouse_user') {
				this.client = '';
			} else if (this.user_type == 'client_user') {
				this.warehouse = '';
			} else {
				this.client = '';
				this.warehouse = '';
				// this.warehouseid = '';
			}
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/invoiceErrorReport/invoiceErrorReport.component.js